import { useState } from 'react';
import Modal from 'react-modal';
import Cookie from 'js-cookie';

const modalStyles = {
  content: {
    backgroundColor: '#fff',
    backgroundImage: 'url(images/newsletter_popup_bg.jpg)',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    top: 'auto',
    outline: 'none',
    width: '100%',
    marginLeft: '1rem',
    marginRight: '1rem'
  }
};

Modal.setAppElement('#__next');

export default function CartAlertModal({ isOpen, setIsOpen, productsList }) {
  // const [ modalIsOpen, setOpenNewsletter ] = useState( false );
  const [doNotShow, setDoNotShow] = useState(false);

  // useEffect( () => {
  //     let timer;
  //     Cookie.get( "hideNewsletter" ) || ( timer = setTimeout( () => {
  //         setOpenNewsletter( true );
  //     }, 5000 ) );
  //
  //     return () => {
  //         timer && clearTimeout( timer );
  //     };
  // }, [] );

  function closeModal() {
    if (!document.querySelector('.mfp-newsletter.open-modal')) return;
    document
      .querySelector('.mfp-newsletter.open-modal')
      .classList.add('close-modal');

    setTimeout(() => {
      setIsOpen();

      doNotShow &&
        Cookie.set('hideNewsletter', 'true', {
          expires: 7,
          path: router.basePath
        });
    }, 350);
  }

  function handleChange(event) {
    setDoNotShow(event.target.checked);
  }

  const outOfStock = [];
  const stock = [];
  productsList.forEach(product => {
    if (product.quantity === 0) {
      outOfStock.push(product);
    } else {
      stock.push(product);
    }
  });

  return (
    <Modal
      className="newsletter-popup bg-img"
      isOpen={!!productsList?.length && isOpen}
      onRequestClose={closeModal}
      overlayClassName="mfp-bg mfp-newsletter d-flex align-items-center justify-content-center open-modal"
      style={modalStyles}>
      <div>
        <img
          alt="BuyOnTrust Logo"
          height="41"
          src="/images/home/logo_red.png"
          width="104"
        />

        {stock?.length > 0 && (
          <>
            <h2>The quantity in your cart will be adjusted to match the available stock:</h2>
            {stock.map((prod, index) => (
              <h6 key={index}>
                - {prod.name} - remaining in stock: {prod.quantity}
              </h6>
            ))}
          </>
        )}

        {outOfStock?.length > 0 && (
          <>
            <h2> Sorry, these products are unavailable for now:</h2>
            {outOfStock.map((prod, index) => (
              <h6 key={index}>- {prod.name} - out of stock</h6>
            ))}
          </>
        )}
      </div>

      <button
        className="mfp-close"
        onClick={closeModal}
        title="Close (Esc)"
        type="button">
        ×
      </button>
    </Modal>
  );
}
